var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.722.788c-.22-.269-.55-.417-.927-.417-.206 0-.424.043-.648.129L.912 6.316c-.809.309-.918.772-.91 1.02.006.249.141.705.966.968l.015.004 3.16.904 1.71 4.888c.233.666.756 1.08 1.365 1.08.384 0 .762-.16 1.093-.465l1.954-1.8 2.836 2.283.028.022.007.006c.316.245.66.374.995.374.657 0 1.18-.486 1.332-1.238L17.96 2.035c.1-.495.016-.938-.237-1.247zM5.2 9.041l6.097-3.115L7.501 9.96a.526.526 0 00-.128.235L6.64 13.16 5.2 9.04zm2.395 4.898a1 1 0 01-.076.063l.68-2.75 1.235.994-1.839 1.693zm9.33-12.114L14.43 14.153c-.024.118-.101.392-.299.392-.097 0-.22-.053-.345-.15l-3.213-2.586-.001-.002-1.912-1.539 5.49-5.834a.527.527 0 00-.623-.831l-9.03 4.613L1.291 7.3l15.232-5.815a.774.774 0 01.27-.06c.033 0 .09.005.112.03.028.035.063.152.02.37z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tg-logo.ad2d283e61cfdd9de7f974a15e778d83.svg";
export { ForwardRef as ReactComponent };